import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import Share from "../../../commons/Share";
import Pinned from "../../../commons/Pinned";
import {authService} from "../../../auth";
import { setProjectDetails} from "../../../reducer/showAllReducer";
import {setPref} from "../../../reducer/userPref";
import {connect} from "react-redux";
import {Link, NavLink, withRouter} from "react-router-dom";
import HorizontalScroll from 'react-scroll-horizontal';
import { isMobileDevice } from '../../../commons/CommonFunctions';

if (isMobileDevice()) {
    import('../../../commons/styles/responsive-useragent.css').then(() => {
       console.log("Imported mobile css");
    });
}

const TopBar = (props) => {
    const [applyBtnActivated, setApplyBtnActivation] = useState(true);
    let userData = authService.getUserDetailsFromLocalStorage();
    let active = props.active || "home";
    let project = props.projectDetail;
    let id = props.projectDetail  && props.projectDetail.project && props.projectDetail.project.id;
    let entityType = (props.projectDetail && props.projectDetail.participationDetails && props.projectDetail.participationDetails.secondaryEntityType) ;
    let pinned =  (props.projectDetail  && props.projectDetail.pinned) ;
    project.id = id;
    project.entityType = entityType;
    project.pinned = pinned;
    let participantTabVisible = (props.projectDetail  && props.projectDetail.participantTabVisible);
    let guestFacultyTabVisible = (props.projectDetail  && props.projectDetail.guestFacultyTabVisible);
    let adminTabShow = (props.projectDetail  && props.projectDetail.adminTabShow);
    let managePermissionTabShow = (props.projectDetail  && props.projectDetail.managePermissionTabShow);
    let statsTabShow = (props.projectDetail  && props.projectDetail.statsTabShow);
    let stage = (props.projectDetail && props.projectDetail.stage) ;
    let acceptedUserIds = props.projectDetail  && props.projectDetail.acceptedUserIds;
    let studioTabVisible = props.projectDetail  && props.projectDetail.studioTabVisible;
    let feedbackTabVisible = props.projectDetail && props.projectDetail.feedbackTabVisible;
    let userId = props?.location?.state?.userId ? props?.location?.state?.userId : authService.getUserDetailsFromLocalStorage().userId
    const currentTime = new Date().getTime();


    useEffect(() => {
        // window.$(".projtopbar").sticky({topSpacing: 65, responsiveWidth: true});
        // if (window.$('#sticky-wrapper').hasClass('sticky-wrapper'))
        //     window.$('.projectinn').css({'padding-bottom' : '150px'});

        var navPos = window.$('.projtopbar').offset().top - 64;
        window.$(window).scroll(function () {
            var windscroll = window.$(window).scrollTop();
            if (windscroll >= navPos) {
                window.$('.projtopbar').addClass('is-sticky');
            } else {
                window.$('.projtopbar').removeClass('is-sticky');
            }
        });
    });

    const setProjectDetails = function (projectDetails) {
        props.setProjectDetails(projectDetails);
    }

    const parentnav  = { height: '45px'}

    return (
        <div className="projtopbar">
            <div className="projtopbarleft">
                <HorizontalScroll style={parentnav} reverseScroll className="mcustHorizMenu">
                    <ul id="tabs" className="nav">
                        <li className="nav-item">
                            <a href="javascript:void(0)" className={active === "home" ? "active" : ""} onClick={e => active === "home" ? e.preventDefault() : props.changeTab("home")}>About</a>
                        </li>
                        {entityType !== 'JOB' &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "feeds" ? "active" : ""} onClick={e => active === "feeds" ? e.preventDefault() : props.changeTab("feeds")}>Activity</a>
                            </li>
                        }
                        {studioTabVisible && entityType !== 'JOB' && <li className="nav-item">
                            {active === "studio" ? (
                                <a href="javascript:void(0)" className="active">Studio</a>
                            ) : (
                                <Link to={{pathname: `/project/studio/${props.projectDetail.slug}`, state: {userId: userId}}}
                                    //onClick={e => props.changeTab("studio")}
                                    >Studio</Link>
                            )}
                        </li>}
                        {userData  && (participantTabVisible || (acceptedUserIds && acceptedUserIds.includes(userData.userId))) &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "participants" ? "active" : ""} onClick={e => active === "participants" ? e.preventDefault() : props.changeTab("participants")}>{props.projectDetail && props.projectDetail.participationDetails.secondaryEntityType && props.projectDetail.participationDetails.secondaryEntityType !== 'FUNDRAISE' ? 'Participants':'Contributors'}</a>
                            </li>
                        }
                        {guestFacultyTabVisible &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "faculty" ? "active" : ""} onClick={e => active === "faculty" ? e.preventDefault() : props.changeTab("faculty")}>Guest Invitee</a>
                            </li>
                        }

                        {adminTabShow &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "admin" ? "active" : ""} onClick={e => active === "admin" ? e.preventDefault() : props.changeTab("admin")}>Admin</a>
                            </li>
                        }
                        {entityType !== 'JOB' && feedbackTabVisible &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "feedback" ? "active" : ""} onClick={e => active === "feedback" ? e.preventDefault() : props.changeTab("feedback")}>Feedback</a>
                            </li>
                        }
                        {statsTabShow &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "stats" ? "active" : ""} onClick={e => active === "stats" ? e.preventDefault() : props.changeTab("stats")}><i className='iBarGraphs'/></a>
                            </li>
                        }
                        {managePermissionTabShow &&
                            <li className="nav-item">
                                <a href="javascript:void(0)" className={active === "settings" ? "active" : ""} onClick={e => active === "settings" ? e.preventDefault() : props.changeTab("settings")}><i className='iSetting'/></a>
                            </li>
                        }
                    </ul>
                </HorizontalScroll>               
                

                {/*<div className="search_block_top">
                    <span className="search-toggle"></span>
                    <form className="searchbox" method="get" action="">
                        <input
                            className="search_query form-control"
                            type="text"
                            name="search_query"
                            placeholder="Search"
                        />
                        <button
                            type="submit"
                            name="submit_search"
                            className="btn btn-default button-search"
                        >
                            <span>Search</span>
                        </button>
                        <span className="search-close"></span>
                    </form>
                </div>*/}
            </div>
            <div className="projtopbarright">
                <Share shareUrl="/project/feeds/"
                       key={props.projectDetail.shareCount} 
                       entityId={project.id}
                       sharesCount={props.projectDetail.shareCount}
                       sharingSetting={props.projectDetail.sharingSettingConfigDto}
                       entityType={project.entityType}
                       slug={props.projectDetail.slug}
                       shareId={project.id}/>
                <Pinned item={project} entityType={project && project.entityType}/>


                {props.projectDetail.isApprover !== undefined &&
                props.projectDetail.participationDetails &&
                props.projectDetail.project &&
                (authService.getUserDetailsFromLocalStorage().type !== 'COMPANY' || (props.projectDetail.participationDetails.secondaryEntityType !== 'JOB' && authService.getUserDetailsFromLocalStorage().type === 'COMPANY')) &&
                !props.projectDetail.isApprover &&
                props.projectDetail.canApply &&
                !props.projectDetail.isUserAlreadyApplied
                ? (
                    <a
                        href={"#projectDetails"}
                        //className="btn btn-primary apply"
                        className='disclaimer'
                        onClick={(e) => setProjectDetails(project)}
                        data-toggle="modal">
                        {/* {props.projectDetail.participationDetails.secondaryEntityType === 'FUNDRAISE' ? (props.projectDetail.donation?.donateActive ? 'VIEW and CONTRIBUTE' : "VIEW") : ((currentTime < props.projectDetail?.startDate) || (props.projectDetail?.startDate <= currentTime && currentTime <= props.projectDetail?.endDate)) ? 'VIEW and APPLY' :'VIEW and JOIN'} */}
                        {props.projectDetail.participationDetails.secondaryEntityType === 'FUNDRAISE' ? (props.projectDetail.donation?.donateActive ? 'VIEW and CONTRIBUTE' : "VIEW") : (!props.projectDetail?.isOffLine && (props.projectDetail?.stage === "running" || props.projectDetail?.stage === "upcoming" )) ? 'VIEW and APPLY' : 'VIEW and JOIN'}
                    </a>
                ):
                    <a
                        href={"#projectDetails"}
                        //className="btn btn-primary apply"
                        className='disclaimer'
                        onClick={(e) => setProjectDetails(project)}
                        data-toggle="modal">
                        VIEW
                    </a>
                }

            </div>




        </div>

    );
};

TopBar.propTypes = {
    changeTab: PropTypes.func.isRequired,
    active: PropTypes.string.isRequired,
}



const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (projectDetails) =>
            dispatch(setProjectDetails(projectDetails)),
        getPref: () => dispatch(setPref()),
    };
};

export default withRouter(connect(null, mapDispatchToProps)(TopBar));

